import { render, staticRenderFns } from "./BasePhotoSport.vue?vue&type=template&id=df16d3d4&scoped=true&"
import script from "./BasePhotoSport.vue?vue&type=script&lang=js&"
export * from "./BasePhotoSport.vue?vue&type=script&lang=js&"
import style0 from "./BasePhotoSport.vue?vue&type=style&index=0&id=df16d3d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df16d3d4",
  null
  
)

export default component.exports